import {
  AppliedDiscountFragment,
  ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType,
} from '../../../../gql/graphql';
import {
  Discount,
  DiscountSourceType,
  DiscountScope as DiscountScopeV2,
  DiscountScopeWithLiterals,
} from '@wix/auto_sdk_ecom_cart-v-2';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {SPECS} from '../../../../common/constants';

export class CouponDiscountModel {
  public scope?: DiscountScope;
  public totalAmountOff?: string;
  public targetLineItemIds: string[];
  /**
   * @deprecated
   */
  public isFreeShippingCoupon?: boolean;

  constructor(params: CouponDiscountModel) {
    this.isFreeShippingCoupon = params.isFreeShippingCoupon;
    this.scope = params.scope;
    this.totalAmountOff = params.totalAmountOff;
    this.targetLineItemIds = params.targetLineItemIds;
  }

  public static fromCheckoutV1(appliedDiscounts: (AppliedDiscountFragment | null)[], modelContext: ModelContext) {
    const couponAlignmentInCartAndCheckout = modelContext?.flowAPI.experiments.enabled(
      SPECS.CouponAlignmentInCartAndCheckout
    );
    const discount = appliedDiscounts.find((discount) => discount?.coupon);
    const coupon = discount?.coupon;
    let scope: DiscountScope | undefined;

    if (couponAlignmentInCartAndCheckout) {
      scope =
        discount?.discountType === ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType.SHIPPING
          ? DiscountScope.DELIVERY
          : DiscountScope.CART_SUBTOTAL;
    }

    if (!coupon) {
      return undefined;
    }

    return new CouponDiscountModel({
      isFreeShippingCoupon: couponAlignmentInCartAndCheckout
        ? undefined
        : discount?.discountType === ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType.SHIPPING,
      scope,
      totalAmountOff: undefined,
      targetLineItemIds: [],
    });
  }

  public static fromCartV2(discounts?: Discount[], modelContext?: ModelContext) {
    const couponAlignmentInCartAndCheckout = modelContext?.flowAPI.experiments.enabled(
      SPECS.CouponAlignmentInCartAndCheckout
    );
    const coupon = discounts?.find((discount) => discount.source?.sourceType === DiscountSourceType.COUPON);

    if (!coupon) {
      return undefined;
    }

    return new CouponDiscountModel({
      isFreeShippingCoupon: couponAlignmentInCartAndCheckout ? undefined : coupon.scope === DiscountScope.DELIVERY,
      scope: couponAlignmentInCartAndCheckout ? toCouponDiscountScopeV2(coupon.scope) : undefined,
      totalAmountOff: '**$100.00**',
      targetLineItemIds: couponAlignmentInCartAndCheckout
        ? coupon.benefits?.map((benefit) => benefit.lineItemId).filter((id) => id !== null && id !== undefined) ??
          /* istanbul ignore next */ []
        : [],
    });
  }
}

export enum DiscountScope {
  DELIVERY = 'DELIVERY',
  LINE_ITEM = 'LINE_ITEM',
  CART_SUBTOTAL = 'CART_SUBTOTAL',
}

const toCouponDiscountScopeV2 = (discountScope?: DiscountScopeWithLiterals) => {
  /* istanbul ignore next */
  if (!discountScope) {
    return undefined;
  }

  switch (discountScope) {
    case DiscountScopeV2.DELIVERY:
      return DiscountScope.DELIVERY;
    case DiscountScopeV2.LINE_ITEM:
      return DiscountScope.LINE_ITEM;
    case DiscountScopeV2.CART_SUBTOTAL:
    case DiscountScopeV2.UNKNOWN_DISCOUNT_SCOPE:
      return DiscountScope.CART_SUBTOTAL;
  }
};
